import createSchemerDecorator from './createSchemerDecorator'
import {
  FieldConfig,
  FieldConfigOutput,
  DEFAULT_FIELD_CONFIG,
  TABLE_FIELDS,
  INPUT_FIELDS,
  ArrayConfig,
  ModelConfig,
} from './constants'
import {
  cacheToMetadata
} from './utils'
import SchemerModel from '../SchemerModel'

export default function createTypeDecorator (typeSymbol: symbol, defaultTypeConfig: FieldConfig|ModelConfig|ArrayConfig) {
  return createSchemerDecorator(
    (
      target: SchemerModel,
      propertyName: string,
      fieldConfigInitial?: FieldConfig|ModelConfig|ArrayConfig
    ) : FieldConfigOutput => {
      const config = Object.assign({
        $type: typeSymbol
      }, DEFAULT_FIELD_CONFIG, defaultTypeConfig, fieldConfigInitial || {})

      if (config.table) cacheToMetadata(TABLE_FIELDS, target, propertyName)
      if (config.input) cacheToMetadata(INPUT_FIELDS, target, propertyName)

      return config
    }
  )
}